import { makeStyles } from "@material-ui/core";

export const RechargeSideBarCss = makeStyles((theme) => ({

    transactionDetailsDrawer: {
        width: 475,
        maxWidth: 475,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px',
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px',
        }
    },
    divTitle: {
        display: 'flex',
        alignItems: 'center',
        color: "#0b1323",
        fontSize: 18,
        marginBottom: 4,
        fontWeight: 600
    },
    sideBarDialogContentV1: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingTop: 32,
        paddingLeft: 30,
        paddingRight: 30,
        paddingBottom: 24,
        backgroundColor: '#f6f6f8'
    },
    titleLeft: {
        fontSize: 12,
        fontWeight: 500,
        color: 'rgba(11, 19, 35, 0.5)',
        textAlign: 'left'
    },
    titleRight: {
        fontSize: 12,
        fontWeight: 500,
        color: 'rgba(11, 19, 35, 0.5)',
        textAlign: 'right'
    },
    gridVehicleNumber: {
        display: 'flex',
        alignItems: 'start',
        fontWeight: 'bold',
        fontSize: 16,
        marginTop: 4
    },
    mlV1: {
        marginLeft: 4
    },
    fuelBalance: {
        marginTop: 4,
        fontWeight: 'bold',
        fontSize: 16,
        textAlign: 'right'
    },
    gridContainer: {
        padding: '16px 24px',
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#f1f1f3'
    },
    textFieldV1: {
        "& .MuiOutlinedInput-root": {
            backgroundColor: 'white !important'
        }
    },
    titleV1: {
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.75)',
        fontWeight: 600,
        marginBottom: 8
    },
    rechargeButton: {
        paddingTop: '17px',
        paddingBottom: '17px',
        borderRadius: '8px',
        backgroundColor: '#00875a',
        color: 'white',
        fontWeight: 600,
        boxShadow: 'none !important',
        "&:hover": {
            backgroundColor: '#00875a'
        }
    },
    divFormContainer: {
        padding: '16px',
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#f6f6f8',
        marginTop: 32
    },
    divAlign: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 24
    },
    amountText: {
        fontSize: 16,
        fontWeight: 'bold'
    },
    sideBarActions: {
        padding: '14px 16px'
    },
    listContainer: {
        padding: 24,
        borderRadius: 8,
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#f1f1f3'
    },
    circle: {
        borderRadius: "50%",
        backgroundColor: "#0085ff",
        fontSize: 12,
        color: "#0085ff",
    },
    divAlignV1: {
        display: 'flex',
        alignItems: 'flex-start',
        marginTop: '4px'
    },
    divAlignV3: {
        display: 'flex',
        marginTop: 16
    },
    divAlignV2: {
        display: 'flex',
    },
    mlV2: {
        marginLeft: 16
    },
    disableCta: {
        paddingTop: '17px',
        paddingBottom: '17px',
        borderRadius: '8px',
        backgroundColor: '#dadada',
        color: '#5e636c',
        fontWeight: 600,
        boxShadow: 'none !important',
        "&:hover": {
            backgroundColor: '#dadada'
        }
    }
}));
